import httpService from '../../../core/services/HttpService';
import type { ApplicationFormConfig } from '../types';

const BASE_URL = '/api/admin/recruiting';

export default class FormConfigService {
  static async getFormConfig(): Promise<ApplicationFormConfig> {
    const response = await httpService.get<ApplicationFormConfig>(`${BASE_URL}/form-config/`);
    return response.data;
  }

  static async updateFormConfig(data: Partial<ApplicationFormConfig>): Promise<ApplicationFormConfig> {
    const response = await httpService.put<ApplicationFormConfig>(`${BASE_URL}/form-config/`, data);
    return response.data;
  }

  static async uploadEmailLogo(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await httpService.post<{ email_logo_url: string }>(
      `${BASE_URL}/form-config/email-logo/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data.email_logo_url;
  }

  static async deleteEmailLogo(): Promise<void> {
    await httpService.delete(`${BASE_URL}/form-config/email-logo/`);
  }
}
